import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import store from '../store'
import Reservation from '../views/Reservation.vue';
import CancelReservation from '../views/CancelReservation.vue';
import BookService from '../views/BookService.vue';
import Reservations from '../views/Reservations.vue';
import Profile from '../views/Profile.vue';
import EditProfile from '../views/EditProfile.vue';
import ChangePassword from '../views/ChangePassword.vue';
import ForgotPassword from '../views/ForgotPassword.vue';
import ResetPassword from '../views/ResetPassword.vue';
import TransactionsLog from '../views/account/TransactionsLog.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    meta: { requiresAuth: true },
    component: Home
  },  
  {
    path: '/',
    name: 'book-servie',
    meta: { requiresAuth: false },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import('../views/BookService.vue')
    component: BookService
  },
  {
    path: '/reservations',
    name: 'reservations',
    meta: { requiresAuth: true },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import('../views/Reservations.vue')
    component: Reservations
  },
  {
    path: '/r/:id',
    name: 'reservationDetails',
    meta: { requiresAuth: true },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ '../views/Reservation.vue')
    component: Reservation
  },
  {
    path: '/sr/:hash',
    name: 'reservationSecureDetails',
    meta: { requiresAuth: false },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ '../views/Reservation.vue')
    component: Reservation
  },
  {
    path: '/c/:id',
    name: 'cancelReservation',
    meta: { requiresAuth: false },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //: () => import(/* webpackChunkName: "about" */ '../views/CancelReservation.vue')
    component: CancelReservation
  },
  {
    path: '/profile',
    name: 'profile',
    meta: { requiresAuth: false },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ '../views/Profile.vue')
    component: Profile
  },
  {
    path: '/ep',
    name: 'editProfile',
    meta: { requiresAuth: true },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/EditProfile.vue')
    component: EditProfile
  },
  {
    path: '/transactions',
    name: 'transactions',
    meta: { requiresAuth: true },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/account/TransactionsLog.vue')
    component: TransactionsLog
  },
  {
    path: '/changePassword',
    name: 'changePassword',
    meta: { requiresAuth: false },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/ChangePassword.vue')
    component: ChangePassword
  },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    meta: { requiresAuth: false },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/ForgotPassword.vue')
    component: ForgotPassword
  },
  {
    path: '/resetPassword/:email/:token',
    name: 'resetPassword',
    meta: { requiresAuth: false },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/ResetPassword.vue')
    component: ResetPassword
  },
  {
    path: '/login',
    name: 'login',
    meta: { requiresAuth: false },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Login //() => import(/* webpackChunkName: "about" */ '../views/Log.vue')
  }
]

const router = new VueRouter({
	mode: 'hash',
	//mode: 'history',
	//base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
  //on booking form we might need the authenticated user
  // let shouldTryLogin = to.name == "book-servie";
  // if(shouldTryLogin){
  //   store.dispatch("account/tryGetToken");
  // }

  let toRequiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  let isAuthenticated = store.getters["account/isAuthenticated"];
  if (toRequiresAuth && !isAuthenticated) {
    if (to.path) {
      next({ name: "login", query: { redirect: to.path } });
    } else {
      next("/login");
    }
  } else next();
});

export default router
